import Reflux from "reflux";

export default {
  generateNewLinkedRecord: Reflux.createAction({sync: true}),
  validateAndGenerateRecord: Reflux.createAction({sync: true}),
};
